export default __webpack_public_path__ + "static/media/collections_8.b83fe894.webp";